export const changelogin = "CHANGELOGIN";
export const changedetails = "CHANGEDETAILS";
export const changeselectedtype = "CHANGESELECTEDTYPE";
export const changepassportdetails = "CHANGEPASSPORTDETAILS";